import { useState } from "react";
import {
    Box,
    Typography,
    Modal,
    IconButton,
    Button,
    CardMedia,
    CircularProgress
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CheckIcon from "@mui/icons-material/Check";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import AddPhotoAlternateIcon from "@mui/icons-material/AddPhotoAlternate";
import SaveIcon from "@mui/icons-material/Save";
import ImageDropzone from "../SharedArea/ImageDropzone";
import additionalInfo from "../../Mobx/AdditionalInfo";
import imageStore from "../../Mobx/Images";
import urls from "../../Mobx/Urls";
import { observer } from "mobx-react-lite";

const ImagePopup = ({ open, onClose, selectedWord }) => {
    const images = imageStore.imagesMap[selectedWord?.additionalInfo] || [];
    const newImages = additionalInfo.newInfo.image || [];
    const [loadingAddExistsInfo, setLoadingAddExistsInfo] = useState(false);

    const renderImageBox = (src, alt, actions) => (
        <Box
            key={alt}
            sx={{
                width: "50%",
                boxSizing: "border-box",
                p: 1,
                position: "relative",
            }}
        >
            <CardMedia
                component="img"
                height="120"
                image={src}
                alt={alt}
                sx={{ borderRadius: 2, width: "100%", objectFit: "cover" }}
            />
            <Box sx={{ position: "absolute", top: 9, right: 9, display: "flex", gap: 0.2 }}>
                {actions}
            </Box>
        </Box>
    );

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "white",
                p: 3,
                borderRadius: 2,
                minWidth: 600,
                maxHeight: "90vh",
                overflow: "auto"
            }}>
                {selectedWord && (
                    <>
                        {/* טקסטים */}
                        <Box display="flex" justifyContent="center" alignItems="baseline" gap={2} mb={2} sx={{ direction: /[\u0590-\u05FF]/.test(selectedWord.original) ? "ltr" : "rtl" }}>
                            <Typography variant="h6" fontWeight={600} sx={{ direction: /[\u0590-\u05FF]/.test(selectedWord.original) ? "rtl" : "ltr" }}>
                                {selectedWord.original}
                            </Typography>
                            <Typography variant="body2" color="text.secondary" sx={{ direction: /[\u0590-\u05FF]/.test(selectedWord.trns) ? "rtl" : "ltr" }}>
                                {selectedWord.trns}
                            </Typography>
                            <Typography variant="caption" color="text.disabled" sx={{ direction: /[\u0590-\u05FF]/.test(selectedWord.pos) ? "rtl" : "ltr" }}>
                                {selectedWord.pos}
                            </Typography>
                        </Box>

                        {/* העלאה ויצירה */}
                        <Box display="flex" justifyContent="center" gap={2} mb={0}>
                            <Box flex={1}>
                                {/* <ImageDropzone onUploadSuccess={() => imageStore.updateImages(selectedWord.additionalInfo)} /> */}
                                <ImageDropzone onUploadSuccess={() => { }} />
                            </Box>
                            <Box flex={1}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    startIcon={<AddPhotoAlternateIcon />}
                                    onClick={() => additionalInfo.createWithAi("image")}
                                    disabled={additionalInfo.loading.create.image}
                                    sx={{ height: "44px" }}
                                >
                                    {additionalInfo.loading.create.image ? <CircularProgress size={24} /> : "צור תמונה עם AI"}
                                </Button>
                            </Box>
                        </Box>

                        {/* אזור תמונות */}
                        <Box display="flex" gap={2}>
                            {/* שמורות */}
                            <Box flex={1} sx={{ maxHeight: 350, minHeight: 350, overflowY: "auto", p: 1, border: "1px solid #ccc", borderRadius: 2, direction: "rtl" }}>
                                <Typography variant="subtitle1" textAlign="center" mb={1}>תמונות שמורות</Typography>
                                <Box display="flex" flexWrap="wrap">
                                    {images.map((image, i) =>
                                        renderImageBox(
                                            `${urls.file.getImage}${image.fileName}`,
                                            `תמונה ${i + 1}`,
                                            <>
                                                {/* כפתור מחיקה */}
                                                <IconButton
                                                    sx={{ bgcolor: "rgba(255,255,255,0.7)", maxHeight: 35, maxWidth: 35 }}
                                                    onClick={async () => {
                                                        await additionalInfo.deleteExistsInfo(
                                                            selectedWord.additionalInfo,
                                                            "images",
                                                            image._id
                                                        );
                                                    }}
                                                    disabled={additionalInfo.loading.deleteExistsInfo.images?.[image._id]}
                                                >
                                                    {additionalInfo.loading.deleteExistsInfo.images?.[image._id] ? (
                                                        <CircularProgress size={19} />
                                                    ) : (
                                                        <DeleteIcon color="error" />
                                                    )}
                                                </IconButton>

                                                {/* כפתור הצגה/הסתרה */}
                                                <IconButton
                                                    sx={{ bgcolor: "rgba(255,255,255,0.7)", maxHeight: 35, maxWidth: 35 }}
                                                    onClick={async () => {
                                                        const newHidden = !image.hidden;
                                                        await additionalInfo.updateExistsInfo(
                                                            selectedWord.additionalInfo,
                                                            "images",
                                                            image._id,
                                                            { hidden: newHidden }
                                                        );
                                                    }}
                                                    disabled={additionalInfo.loading.updateExistsInfo.images?.[image._id] === "hidden"}
                                                >
                                                    {additionalInfo.loading.updateExistsInfo.images?.[image._id] === "hidden" ? (
                                                        <CircularProgress size={19} />
                                                    ) : (
                                                        image.hidden ? <VisibilityOffIcon sx={{ color: 'error.main' }} /> : <VisibilityIcon color="action" />
                                                    )}
                                                </IconButton>

                                                {/* כפתור ברירת מחדל */}
                                                {image.default ? (
                                                    <Typography
                                                        variant="caption"
                                                        color="primary"
                                                        sx={{
                                                            px: 1.5,
                                                            py: 0.5,
                                                            bgcolor: "rgba(255,255,255,0.7)",
                                                            borderRadius: 1,
                                                            maxWidth: 50,
                                                            direction: "ltr",
                                                        }}
                                                    >
                                                        ברירת מחדל
                                                    </Typography>
                                                ) : (
                                                    <IconButton
                                                        sx={{ bgcolor: "rgba(255,255,255,0.7)", maxHeight: 35, maxWidth: 35 }}
                                                        onClick={async () => {
                                                            await additionalInfo.updateExistsInfo(
                                                                selectedWord.additionalInfo,
                                                                "images",
                                                                image._id,
                                                                { default: true }
                                                            );
                                                        }}
                                                        disabled={additionalInfo.loading.updateExistsInfo.images?.[image._id] === "default"}
                                                    >
                                                        {additionalInfo.loading.updateExistsInfo.images?.[image._id] ===
                                                            "default" ? (
                                                            <CircularProgress size={19} />
                                                        ) : (
                                                            <CheckIcon color="primary" />
                                                        )}
                                                    </IconButton>
                                                )}
                                            </>
                                        )
                                    )}
                                </Box>
                            </Box>

                            {/* AI */}
                            <Box flex={1} sx={{ maxHeight: 350, minHeight: 350, overflowY: "auto", p: 1, border: "1px solid #ccc", borderRadius: 2, direction: "rtl" }}>
                                <Typography variant="subtitle1" textAlign="center" mb={1} sx={{ direction: 'ltr' }}>תמונות שנוצרו עם AI</Typography>
                                <Box display="flex" flexWrap="wrap">
                                    {newImages.map((image, index) =>
                                        renderImageBox(
                                            image,
                                            `תמונה חדשה ${index + 1}`,
                                            <>
                                                <IconButton
                                                    sx={{ bgcolor: "rgba(255,255,255,0.7)" }}
                                                    onClick={() => additionalInfo.deleteNewInfo("image", index)}
                                                    disabled={loadingAddExistsInfo}
                                                >
                                                    <DeleteIcon
                                                        sx={{
                                                            color: loadingAddExistsInfo ? "gray" : "error.main"
                                                        }}
                                                    />
                                                </IconButton>

                                                <IconButton
                                                    sx={{ bgcolor: "rgba(255,255,255,0.7)" }}
                                                    onClick={async () => {
                                                        setLoadingAddExistsInfo(true);
                                                        try {
                                                            await additionalInfo.addExistsInfo({
                                                                fields: { image },
                                                                field: "images",
                                                                index,
                                                                _id: selectedWord.additionalInfo
                                                            });
                                                        } finally {
                                                            setLoadingAddExistsInfo(false);
                                                        }
                                                    }}
                                                    disabled={loadingAddExistsInfo || additionalInfo.loading.addExistsInfo.images?.[index]}
                                                >
                                                    {additionalInfo.loading.addExistsInfo.images?.[index] ? (
                                                        <CircularProgress size={19} />
                                                    ) : (
                                                        <SaveIcon sx={{
                                                            color: loadingAddExistsInfo ? "gray" : "primary.main"
                                                        }} />
                                                    )}
                                                </IconButton>
                                            </>
                                        )
                                    )}
                                </Box>
                            </Box>
                        </Box>
                    </>
                )}
            </Box>
        </Modal>
    );
};

export default observer(ImagePopup);
